import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/input
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InputCommand from './inputcommand';
import injectUnsafeKeystrokesHandling from './utils/injectunsafekeystrokeshandling';
import injectTypingMutationsHandling from './utils/injecttypingmutationshandling';
/**
 * Handles text input coming from the keyboard or other input methods.
 *
 * @extends module:core/plugin~Plugin
 */

var Input = /*#__PURE__*/function (_Plugin) {
  _inherits(Input, _Plugin);

  var _super = _createSuper(Input);

  function Input() {
    _classCallCheck(this, Input);

    return _super.apply(this, arguments);
  }

  _createClass(Input, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var editor = this.editor; // TODO The above default configuration value should be defined using editor.config.define() once it's fixed.

      var inputCommand = new InputCommand(editor, editor.config.get('typing.undoStep') || 20);
      editor.commands.add('input', inputCommand);
      injectUnsafeKeystrokesHandling(editor);
      injectTypingMutationsHandling(editor);
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'Input';
    }
  }]);

  return Input;
}(Plugin);

export { Input as default };